/** Represents a device type. */
export enum BarDeviceType{
    /** Desktop. */
    Desktop,
    /** Tablet. */
    Tablet,
    /** Smartphone, GSM, handheld. */
    Mobile,
    /** Unknown device type. */
    Unknown
}